import { useState, useEffect } from 'react';
import { API_BASE } from '../config';

export const useHandbooks = () => {
  const [handbooks, setHandbooks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadHandbooks = async (forceReload = false) => {
    setIsLoading(true);
    setError(null);

    // Добавляем минимальную задержку для лучшего UX
    const startTime = Date.now();
    const minLoadingTime = 500; // 500ms минимальное время показа лоадера

    try {
      // Проверяем кэш
      if (!forceReload) {
        const cached = localStorage.getItem('handbooks_cache');
        const cacheTime = localStorage.getItem('handbooks_cache_time');
        
        if (cached && cacheTime) {
          const cacheAge = Date.now() - parseInt(cacheTime);
          const maxCacheAge = 24 * 60 * 60 * 1000; // 24 часа
          
          if (cacheAge < maxCacheAge) {
            const parsed = JSON.parse(cached);
            setHandbooks(parsed);
            setIsLoading(false);
            return;
          }
        }
      }

      // Загружаем данные
      const response = await fetch(`${API_BASE}/all-guide/`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      const handbooksData = data.handbooks || [];
      
      const elapsedTime = Date.now() - startTime;
      const remainingTime = Math.max(0, minLoadingTime - elapsedTime);
      
      setTimeout(() => {
        setHandbooks(handbooksData);
        
        // Сохраняем в кэш
        const timestamp = Date.now();
        localStorage.setItem('handbooks_cache', JSON.stringify(handbooksData));
        localStorage.setItem('handbooks_cache_time', timestamp.toString());
        
        setIsLoading(false);
      }, remainingTime);
      
    } catch (err) {
      const elapsedTime = Date.now() - startTime;
      const remainingTime = Math.max(0, minLoadingTime - elapsedTime);
      
      setTimeout(() => {
        setError(err.message);
        setIsLoading(false);
      }, remainingTime);
    }
  };

  useEffect(() => {
    loadHandbooks();
  }, []);

  return {
    handbooks,
    isLoading,
    error,
    loadHandbooks
  };
};
